Dodano nową sesję prywatną
<lib-quick-link
  [contextId]="details.privateSessionId"
  [context]="'PrivateSession'"
></lib-quick-link>
dla
{{ ob | objectLabel: details.organizationClientId | async }}
<lib-quick-cover
  [contextId]="details.privateSessionId"
  [context]="'PrivateSession'"
  [maxSize]="2048"
  [routerLink]="('PrivateSession' | quickLinkForRouter:details.privateSessionId) | async"
></lib-quick-cover>
